import { type BrandPageSeo, type SeoPageKey } from '@/brands/types';

import type { Metadata } from 'next';

/**
 * Labels das páginas (independentes de brand). O sufixo "| <site>" é adicionado
 * pelo `title.template` definido no `Metadata` raiz de cada brand.
 */
const PAGE_TITLES: Record<SeoPageKey, string> = {
  about: 'Sobre nós',
  luckyWheel: 'Giro da Sorte',
  support: 'Suporte',
  results: 'Resultados',
  wallet: 'Carteira',
};

/**
 * Gera o bloco de SEO das páginas internas a partir do nome do site (whitelabel).
 * Cada brand exporta seu próprio `xPageSeo` chamando esta função; o texto pode ser
 * substituído por copy específica do brand quando necessário. Também serve de
 * fallback genérico em `getPageMetadata` quando um brand não define a página.
 */
export function buildPageSeo(displayName: string): BrandPageSeo {
  return {
    about: {
      title: PAGE_TITLES.about,
      description: `Saiba mais sobre o ${displayName}. Conheça nossa missão e saiba como ter a chance de ganhar na loteria de prêmios instantâneos comprando bilhetes da sorte.`,
    },
    luckyWheel: {
      title: PAGE_TITLES.luckyWheel,
      description: `Experimente o Giro da Sorte do ${displayName} e tenha ainda mais chances de ganhar! Gire agora e divirta-se.`,
    },
    support: {
      title: PAGE_TITLES.support,
      description: `Precisa de ajuda? Veja a página de Suporte do ${displayName} e tire suas dúvidas sobre sorteios, bilhetes e participação.`,
    },
    results: {
      title: PAGE_TITLES.results,
      description: `Confira se você foi um dos ganhadores da vez do ${displayName}. Veja os contemplados do sorteio, recompensas e mais.`,
    },
    wallet: {
      title: PAGE_TITLES.wallet,
      description: `Veja seus prêmios, bilhetes e mais na sua carteira no ${displayName}. Monitore sua conta e saldo disponível aqui.`,
    },
  };
}

/**
 * Título da Home: `default` é o título absoluto (fora do padrão "Label | site") e
 * `template` define o sufixo aplicado às páginas filhas. Usado no `Metadata` raiz.
 */
export function buildHomeTitle(displayName: string): NonNullable<Metadata['title']> {
  return {
    default: `${displayName} - Bilhetes premiados e loteria`,
    template: `%s | ${displayName}`,
  };
}

/** Description da Home, usada no `Metadata` raiz de cada brand. */
export function buildHomeDescription(displayName: string): string {
  return `Bem-vindo ao ${displayName}! Compre seu bilhete da sorte e concorra a prêmios instantâneos no pix. Sua chance de ganhar na loteria começa aqui!`;
}
